import React from "react";

export default function Section12() {
  const services = [
    {
      title: "Conversion-Ready Shopify Stores",
      description: `As certified Shopify Partners, we build stores that convert visitors into customers. With clear calls to action, optimized product pages, and streamlined checkout, our Shopify web developers in New York ensure every ecommerce site delivers fast, reliable performance and a seamless shopping experience.`,
    },
    {
      title: "Scalable Shopify Store",
      description: `Scaling a Shopify store requires more than just adding products. Mean3 builds scalable Shopify store development with a clean technical foundation that handles growing traffic, larger catalogs, and higher order volumes while maintaining consistent speed and reliability at every stage.`,
    },
  ];

  return (
    <div className="w-full Section11">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        <h1 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Shopify Web Development Company for Scalable  Ecommerce Solutions in New York
        </h1>
        <p className="leading-[22px] text-[#373737] pb-[1%] text-sm md:text-base mb-[20px]">
          At Mean3, we deliver professional Shopify web development in New York tailored for businesses across the state. As a trusted Shopify web development agency, our approach combines structured backend development with conversion-focused storefront design. Every Shopify website we build is engineered for speed, responsiveness, scalability, and long-term operational reliability in competitive markets.
        </p>

        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#f5f5f5] text-[#373737]"} p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px]`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
